import { useTranslation } from 'react-i18next';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';

export function ExchangeSourceDisconnectedNotification({ id, onDismiss, targetName }) {
    const { t } = useTranslation();

    return (
        <Snackbar id={id} onDismiss={onDismiss} autoHideEnabled variant={SnackbarVariant.SUCCESS}>
            <SnackbarMessage>
                {t(`notifications:ExchangeSourceDisconnected`, {
                    target: targetName
                })}
            </SnackbarMessage>
        </Snackbar>
    );
}
